import * as types from '@store/types'
import axios from 'axios'
import store from '@store'
import terms from '@routes/terms'
import Logged from '@views/Logged'
import transactionRoutes from '@router/transaction'

function hasPermission (permission) {
  const permissions = store.getters[types.COMPANY_PERMISSIONS] || []
  return permissions.some((v) => v === permission)
}

export default [
  {
    meta: { unauthenticated: true },
    path: '/login',
    name: 'Login',
    beforeEnter: async (to, from, next) => {
      const { company, token, ...params } = { ...to.query }
      await store.dispatch(types.AUTH, { company, token })
      if (params.error) { return next({ name: 'Erro' }) }

      if (params.campaign) {
        return next({
          name: 'Detalhes da campanha',
          params: { campaignSlug: params.campaign }
        })
      }

      if (params.partner || params.category) {
        return next({
          name: 'Campanhas',
          query: { ...params }
        })
      }

      next({ name: 'Home' })
    }
  },
  {
    meta: { unauthenticated: true },
    path: '/terms',
    name: 'public terms',
    redirect: { name: 'Public user terms' },
    component: () => import('@views/PublicTerms'),
    children: [
      {
        meta: { unauthenticated: true },
        path: 'user',
        name: 'Public user terms',
        component: () => import('@components/Terms/TermsUser')
      },
      {
        meta: { unauthenticated: true },
        path: 'privacy',
        name: 'Privacy terms',
        component: () => import('@components/Terms/TermsPrivacy')
      },
      {
        meta: { unauthenticated: true },
        path: 'partner',
        name: 'Partner terms',
        component: () => import('@components/Terms/TermsPartner')
      }
    ]
  },
  {
    meta: { unauthenticated: true },
    path: '/icons',
    name: 'icons',
    component: () => import('@views/Icons')
  },
  {
    path: '/erro',
    name: 'Erro',
    component: () => import('@views/Error')
  },
  {
    meta: { unauthenticated: true },
    path: '/entrar',
    name: 'Entrar',
    component: () => import('@views/LoginPage')
  },
  {
    meta: { unauthenticated: true },
    path: '/ativar-conta',
    name: 'Ativar conta',
    component: () => import('@views/AccountActivate')
  },
  {
    meta: { unauthenticated: true },
    path: '/formulario-de-ativacao',
    component: () => import('@views/ActivateForm'),
    beforeEnter: async (to, from, next) => {
      const { document } = store.getters[types.AUTH_CREDENTIALS]
      if (!document) return next({ name: 'Entrar' })
      next()
    },
    children: [
      {
        meta: { unauthenticated: !store.state.auth.credentials.activate },
        path: '',
        name: 'Formulário de ativação',
        component: () => import('@containers/Login/ActivateForm')
      },
      {
        meta: { unauthenticated: true },
        path: 'termos',
        name: 'Termos',
        redirect: { name: 'Termos do usuário' },
        component: () => import('@views/Terms'),
        children: terms(true)
      }
    ]
  },
  {
    meta: { unauthenticated: true },
    path: '/ativacao-de-conta-alelo',
    name: 'Ativação de conta alelo RH',
    component: () => import('@views/AccountActivateAlelo'),
    beforeRouteLeave: async (next) => {
      const { token } = store.getters[types.AUTH]
      if (token) return next({ name: 'Home' })
    }
  },
  {
    meta: { unauthenticated: true },
    path: '/verificacao',
    name: 'Confirmação de cadastro',
    component: () => import('@views/AccountVerification'),
    beforeEnter: (to, from, next) => {
      const { document } = store.getters[types.AUTH_CREDENTIALS]
      const companies = store.getters[types.CONFIG_COMPANIES]
      if (!document || !companies.length) return next({ name: 'Entrar' })

      next()
    }
  },
  {
    meta: { unauthenticated: true },
    path: '/esqueci-minha-senha',
    name: 'Esqueci minha senha',
    component: () => import('@views/ForgetPassword')
  },
  {
    meta: { unauthenticated: true },
    path: '/nova-senha',
    name: 'Nova senha',
    component: () => import('@views/RecoveryPassword'),
    beforeEnter: async (to, from, next) => {
      try {
        const token = to.query.token || ''
        const { data: { data } } = await axios.post('company/user/remember/check', { token })
        if (!data || !token) return next({ name: 'Entrar' })

        next()
      } catch (err) {
        return next({ name: 'Entrar' })
      }
    }
  },
  {
    path: '/',
    component: Logged,
    beforeEnter (to, from, next) {
      next()
    },
    children: [
      {
        path: '',
        name: 'Home',
        alias: 'home',
        component: () => import('@views/Home')
      },
      {
        path: 'vitrine',
        component: () => import('@views/Campaigns'),
        beforeEnter (to, from, next) {
          if (!to.params.tag) { return next({ name: 'Home' }) }
          next()
        },
        children: [
          {
            name: 'Vitrine',
            meta: { showcase: true },
            path: ':tag',
            component: () => import('@containers/Banner/Showcase')
          }
        ]
      },
      {
        path: 'premios',
        component: () => import('@views/Campaigns'),
        permission: 'awards',
        children: [
          {
            path: '',
            name: 'Premios',
            component: () => import('@containers/Awards/AwardContainer')
          },
          {
            path: ':partnerSlug',
            name: 'Detalhes do premio',
            component: () => import('@containers/Awards/AwardsDetails')
          }
        ]
      },
      {
        path: 'recompensas',
        component: () => import('@views/Engagement'),
        beforeEnter: async (to, from, next) => {
          if (!hasPermission('engagement')) return next({ name: 'Login' })
          next()
        },
        children: [
          {
            path: '',
            name: 'Recompensas',
            component: () => import('@containers/Engagement/EngagementContainer')
          },
          {
            path: 'catalogo',
            name: 'Catálogo de Recompensas',
            component: () => import('@containers/Engagement/EngagementOffersContainer')
          },
          {
            path: ':partnerSlug',
            name: 'Detalhes da recompensa',
            component: () => import('@containers/Engagement/EngagementDetails')
          }
        ]
      },
      {
        path: 'campanhas',
        component: () => import('@views/Campaigns'),
        children: [
          {
            path: '',
            name: 'Campanhas',
            component: () => import('@containers/Search/SearchResults')
          },
          {
            path: ':campaignSlug',
            name: 'Detalhes da campanha',
            component: () => import('@containers/Campaign/CampaignDetails')
            // beforeRouteLeave: async (to, from, next) => {
            //   await store.dispatch(types.BREADCRUMB_NAMES, {})
            //   await store.dispatch(types.BREADCRUMB_ROUTES, [])
            // }
          }
        ]
      },
      {
        path: 'proximos-a-voce',
        name: 'Próximos a você',
        component: () => import('@views/NextToYou')
      },
      {
        path: 'resgates',
        name: 'Resgates',
        redirect: transactionRoutes[0],
        component: () => import('@views/Transactions'),
        children: transactionRoutes
      },
      {
        path: 'termos',
        name: 'Termos logado',
        redirect: { name: 'Termos do usuário logado' },
        component: () => import('@views/Terms'),
        children: terms()
      },
      {
        path: 'cartao-farmacia',
        name: 'Cartão Farmácia',
        permission: 'vidalink',
        component: () => import('@views/Vidalink.vue'),
        beforeEnter: async (to, from, next) => {
          if (!hasPermission('vidalink')) {
            return next({ path: '/' })
          }
          next()
        }
      },
      {
        path: 'perfil',
        name: 'Meu perfil',
        component: () => import('@views/Profile')
      },
      {
        path: 'editar-perfil',
        name: 'Editar perfil',
        component: () => import('@components/Profile/ProfileEdit')
      },
      {
        path: 'alterar-senha',
        name: 'Alterar senha',
        component: () => import('@components/Profile/ProfileEditPassword')
      },
      {
        path: 'seja-parceiro',
        name: 'Seja parceiro',
        component: () => import('@containers/BecomePartner/BecomePartner')
      },
      {
        path: 'carteira',
        name: 'Carteira',
        redirect: { name: 'Prêmios' },
        component: () => import('@views/Wallet'),
        beforeEnter: async (to, from, next) => {
          if (!hasPermission('engagement') && !hasPermission('awards') && !hasPermission('cashback_tab')) {
            return next({ path: '/' })
          }
          next()
        },
        children: [
          {
            path: '',
            name: 'Carteira Cashback',
            component: () => import('@containers/Wallet/WalletContainer')
          },
          {
            path: 'premios',
            name: 'Carteira Prêmios',
            component: () => import('@containers/Wallet/WalletContainer')
          },
          {
            path: 'pontos',
            name: 'Carteira Pontos',
            component: () => import('@containers/Wallet/WalletContainer')
          }
        ]
      },
      {
        path: '*',
        beforeEnter: async (to, from, next) => {
          return next({ path: '/' })
        }
      }
    ]
  }
]



// WEBPACK FOOTER //
// ./src/router/routes/index.js